import styled, { css } from 'styled-components';
import pattern from '../../../images/pattern.svg';
import Mixins from '../../../styles/mixins';

const renderBackground = (props) => {
  const { previewMode, theme } = props;
  const { backgroundImage } = theme;

  if (previewMode || backgroundImage === false) return null;

  if (typeof backgroundImage === 'string' && backgroundImage.length) {
    return css`
      background-image: url(${backgroundImage});
    `;
  }

  return css`
    background-image: url(${pattern});
  `;
};

export default {
  Layout: styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    ${Mixins.fonts};
    font-family: 'Roboto', sans-serif;
    background-color: ${({ theme }) => theme.backgroundColor || '#f5f5f5'};
    ${renderBackground};
    background-repeat: repeat;
    background-position: center center;

    * {
      box-sizing: border-box;
    }
  `,

  CloseButton: styled.button<{ isPeriodical: boolean }>`
    padding: 16px;
    position: absolute;
    top: 0;
    padding: 11px 14px;
    border: 0;
    background: transparent;
    outline: none;
    z-index: 9993;
    font-size: 16px;
    opacity: 0.4;

    ${(props) =>
      props.theme.isRtl
        ? css`
            left: 10px;
          `
        : css`
            right: 10px;
          `}

    svg {
      fill: black;
    }

    &:hover {
      opacity: 1;
    }

    @media screen and (max-width: 700px) {
      top: 6px;
      padding: 7px 11px;

      ${(props) =>
        props.theme.isRtl
          ? css`
              left: 0;
            `
          : css`
              right: 0;
            `}
    }
  `,
};
